// @ helpers
const { getLastNChars } = require('utilities/stringHelper');

// @constants
const keysTppView = {
    AGGREGATOR: "keysTppView-typeAggregator",
    PAYMENT_GATEWAY: "keysTppView-typePaymentGateway",
    ALL: "keysTppView-typeAggregatorPaymentGateway",
}

const getTppTypeKey = (tpp) => {
        const tppTypeValue = tpp.get('type');
        return keysTppView[tppTypeValue] || "";
    }

const filterAccountsInfo = ({ immAccounts, productListId }) => {
    const accountsInfo = immAccounts.reduce((acc, curr) => {
        return [...acc, {
            iban: getLastNChars(curr.get('iban'), 4, '.'),
            alias: curr.get('alias')
        }]
    }, [])

    return accountsInfo.filter(account => {
        return productListId.includes(account.iban)
    })
}




module.exports = { 
    getTppTypeKey,
    filterAccountsInfo
};